<!-- Loading bar -->
@if (loading) {
  <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" mode="indeterminate">
  </mat-progress-bar>
}
<!-- master-data -->
@if (!loading) {
  <div class="flex flex-col flex-auto overflow-y-auto lg:overflow-hidden bg-card dark:bg-default">
    <ng-container *ngTemplateOutlet="quarantineViewMode ? quarantineView : databaseViewMode ? databaseView : summaryView"></ng-container>
  </div>
}

<!-- Data View -->
<ng-template #summaryView>
  <!-- Messages -->
  @if (repo?.dtypeToGoLiveSchedule && showAlerts?.showScheduleToGoLive && role?.dataVerifier && !isNew && !repo.migrating) {
    <div class="flex pl-2 pr-2 items-center w-full bg-amber-100 dark:bg-amber-500">
      <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color mr-2 flex" aria-hidden="true"[svgIcon]="'heroicons_solid:exclamation'"></mat-icon>
      <span class="flex-auto"> {{ scheduleAlert }} </span>
      <button class="flex place-self-end" mat-icon-button matTooltip="{{'close' | transloco}}" (click)="showAlerts.showScheduleToGoLive = false">
        <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }
  @if (repo?.dtypeToGoLiveRequest && showAlerts?.showHasRequestToGoLive && !role?.dataVerifier && !isNew && !repo.migrating) {
    <div class="flex pl-2 pr-2 items-center w-full bg-amber-100 dark:bg-amber-500">
      <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color mr-2 flex" aria-hidden="true"[svgIcon]="'heroicons_solid:exclamation'"></mat-icon>
      <span class="flex-auto"> {{ quarantineScheduled.hasRequestMessage }} </span>
      <button class="flex place-self-end" mat-icon-button matTooltip="{{'close' | transloco}}" (click)="showAlerts.showScheduleToGoLive = false">
        <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }
  @if (repo?.migrating && showAlerts?.showMigrating && !isNew) {
    <div class="flex pl-2 pr-2 items-center w-full bg-red-100">
      <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color mr-2 flex" aria-hidden="true"[svgIcon]="'heroicons_solid:exclamation'"></mat-icon>
      <span class="flex-auto"> {{ 'quarantineScheduled.migratingMessage' | transloco }} </span>
      <button class="flex place-self-end" mat-icon-button matTooltip="{{'close' | transloco}}" (click)="showAlerts.showScheduleToGoLive = false">
        <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
  }
  <!-- Header -->
  <div class="z-10 relative flex flex-row flex-0 w-full border-b bg-gray-100 dark:bg-transparent">
    <div class="flex flex-col flex-auto items-center justify-start">
      <!-- Go to Buttons -->
      <div class="flex p-4 items-center justify-start w-full">

        <!-- Go back-->
        <a mat-raised-button class="mr-4" [routerLink]="['../']"
                    [queryParams]="{
                        ou: params.ou,
                        marca_code: params.marca_code,
                        cliente_code: params.cliente_code,
                        projectId: params.projectId,
                        serviceId: params.serviceId
                    }">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'back' | transloco }}</span>
        </a>

        <!-- Go to data -->
        @if (repo && repo.status !== 'DESIGN') {
          <button mat-raised-button class="mr-4"
            [routerLink]="['../data']" [queryParams]="params">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'data' | transloco }}</span>
          </button>
        }

        <!-- Go to design -->
        @if (repo && sameLocator && repo.status !== 'STATIC' && hasPermissionToDesignRepository()) {
          <button mat-raised-button class="mr-4"
            [routerLink]="['../design']" [queryParams]="params" [disabled]="repo?.locked && repo?.dtypeToGoLiveRequest">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'design' | transloco }}</span>
          </button>
        }

        <!-- Go to BBDD view -->
        @if (role?.dataVerifier) {
          <button mat-raised-button class="mr-4 mat-focus-indicator mat-stroked-button mat-button-base" (click)="changeView()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'tableInfo' | transloco }}</span>
          </button>
        }

        <!-- Go to Quarantine view -->
        @if (!isSystemConfig && repo?.status !== 'STATIC' && repo?.dtypeToGoLiveRequest && repo?.locked && !repo?.dtypeToGoLiveSchedule && role?.dataVerifier && !repo.migrating) {
          <button
            mat-raised-button class="mr-4 bg-green-600 dark:bg-green-600 text-white" (click)="changeQuarantineView()">
            <mat-icon class="mat-icon notranslate icon-size-5 text-white" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'resolveQuarantine' | transloco }}</span>
          </button>
        }

        <!-- Cancel Quarantine -->
        @if (!isSystemConfig && repo?.status !== 'STATIC' && repo?.dtypeToGoLiveRequest && repo?.locked && repo?.dtypeToGoLiveSchedule && role?.dataVerifier && !repo.migrating) {
          <button
            mat-raised-button class="mr-4 bg-red-600 dark:bg-red-600 text-white" (click)="cancelQuarantine()">
            <mat-icon class="mat-icon notranslate icon-size-5 text-white" aria-hidden="true"[svgIcon]="'heroicons_solid:x'"></mat-icon>
            <span class="pl-1">{{ 'quarantineScheduled.cancelLive' | transloco }}</span>
          </button>
        }

        <!-- Hide/Show -->
        @if (!isSystemConfig && repo?.status !== 'STATIC' && !repo?.dtypeToGoLiveRequest && repo?.hidden && role?.masterDataDesigner && !repo.migrating) {
          <button mat-raised-button class="mr-4 primary" (click)="toggleDTypeRepositoryHidden()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
            <span class="pl-1">{{ 'hideRepoDialog.show' | transloco }}</span>
          </button>
        }
        @if (!isSystemConfig && repo?.status !== 'STATIC' && !repo?.dtypeToGoLiveRequest && !repo?.hidden && role?.masterDataDesigner && !repo.migrating) {
          <button mat-raised-button class="mr-4 primary" (click)="toggleDTypeRepositoryHidden()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true" [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
            <span class="pl-1">{{ 'hideRepoDialog.hide' | transloco }}</span>
          </button>
        }

        <!-- Lock/Unlock -->
        @if (!isSystemConfig && repo?.status !== 'STATIC' && !repo?.dtypeToGoLiveRequest && repo?.locked && role?.dataVerifier && !repo.migrating) {
          <button mat-raised-button class="mr-4 bg-green-600 dark:bg-green-600 text-white" (click)="toggleDTypeRepositoryLock()">
            <mat-icon class="mat-icon notranslate icon-size-5 text-white" aria-hidden="true" [svgIcon]="'heroicons_solid:lock-open'"></mat-icon>
            <span class="pl-1">{{ 'blockRepoDialog.unlock' | transloco }}</span>
          </button>
        }
        @if (!isSystemConfig && repo?.status !== 'STATIC' && !repo?.dtypeToGoLiveRequest && !repo?.locked && role?.dataVerifier && !repo.migrating) {
          <button mat-raised-button class="mr-4 bg-red-600 dark:bg-red-600 text-white" (click)="toggleDTypeRepositoryLock()">
            <mat-icon class="mat-icon notranslate icon-size-5 text-white" aria-hidden="true" [svgIcon]="'heroicons_solid:lock-closed'"></mat-icon>
            <span class="pl-1">{{ 'blockRepoDialog.lock' | transloco }}</span>
          </button>
        }
      </div>

      <!-- Title -->
      <div class="px-6 py-4 text-3xl font-semibold tracking-tight w-full flex items-center">
        {{ masterData?.caption ? (masterData.caption | localize) : ('newMasterData' | transloco) }}
        <!-- Icons -->
        @if (!isNew) {
          <!-- Design View -->
          @if (repo?.status === 'DESIGN') {
            <mat-icon class="ml-2" [svgIcon]="'mat_outline:draw'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.design' | transloco}}"></mat-icon>
          }
          <!-- Live View -->
          @if (repo?.status === 'LIVE') {
            <mat-icon class="ml-2" [svgIcon]="'feather:heart'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.live' | transloco}}"></mat-icon>
          }
          <!-- Static View -->
          @if (repo?.status === 'STATIC') {
            <mat-icon class="ml-2" [svgIcon]="'feather:anchor'" [ngStyle]="{'color':'black'}" matTooltip="{{'repositoryIcons.static' | transloco}}"></mat-icon>
          }
          @if (repo?.status !== 'STATIC') {
            <!-- Locked -->
            @if (repo?.locked) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-closed'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.locked' | transloco}}"></mat-icon>
            }
            <!-- Unlocked -->
            @if (!repo?.locked) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_solid:lock-open'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.unlocked' | transloco}}"></mat-icon>
            }
            <!-- Evened -->
            @if (repo?.evened) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-online'" [ngStyle]="{'color':'green'}" matTooltip="{{'repositoryIcons.evened' | transloco}}"></mat-icon>
            }
            <!-- Unevened -->
            @if (!repo?.evened) {
              <mat-icon class="ml-2" [svgIcon]="'heroicons_outline:status-offline'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.unevened' | transloco}}"></mat-icon>
            }
            <!-- Has Request -->
            @if (repo?.dtypeToGoLiveRequest && !repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
              <mat-icon class="ml-2" [svgIcon]="'mat_outline:note_add'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasRequest' | transloco}}"></mat-icon>
            }
            <!-- Has Schedule -->
            @if (repo?.dtypeToGoLiveSchedule && !repo?.migrating) {
              <mat-icon class="ml-2" [svgIcon]="'feather:clock'" [ngStyle]="{'color':'orange'}" matTooltip="{{'repositoryIcons.hasSchedule' | transloco}}"></mat-icon>
            }
            <!-- Migrating -->
            @if (repo?.migrating) {
              <mat-icon class="ml-2" [svgIcon]="'mat_outline:sync_problem'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.migrating' | transloco}}"></mat-icon>
            }
            <!-- Error Status -->
            @if (repo?.errorStatus === 'ERROR') {
              <mat-icon class="ml-2" [svgIcon]="'mat_outline:error_outline'" [ngStyle]="{'color':'red'}" matTooltip="{{'repositoryIcons.errors' | transloco}}"></mat-icon>
            }
          }
        }

        <!-- Download structure -->
        <button mat-raised-button class="ml-4" color="primary" (click)="downloadStructure()">
          <mat-icon [svgIcon]="'mat_outline:download'" class="icon-size-5 text-on-primary"></mat-icon>
          <span>{{ 'structureExcelDownload' | transloco }}</span>
        </button>
      </div>
    </div>

    <!-- Action buttons -->
    <div class="flex flex-col items-start flex-auto">
      <div class="flex p-4 justify-end w-full">
        <!-- Cancel -->
        @if (hasPermissionToDesignRepository() && repo.status !== 'STATIC') {
          <button mat-raised-button class="mr-4" color="warn" (click)="deleteRepository()">{{ 'delete' | transloco }}</button>
        }
      </div>
    </div>
  </div>

  <!-- Alerts -->
  @if (masterData && masterData.alert.length > 0) {
    <div
      class="flex-col w-full py-4 px-8 border-b bg-gray-100 dark:bg-transparent">
      @for (al of masterData.alert; track al) {
        <div class="flex flex-row w-2/5 py-2">
          <fuse-alert [type]="al.type.toLowerCase()" appearance="outline">
            <span fuseAlertTitle>
              {{ al.type === 'ERROR' ? 'Error' : al.type === 'WARNING' ? ('warning' | transloco) : 'Info' }}
            </span>
            {{ $safeNavigationMigration(al?.text) | localize }}
          </fuse-alert>
        </div>
      }
    </div>
  }

  <div class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
    fuseScrollReset>
    <!-- Tabs (except pseudostatic) -->
    @if (masterData && dtypeForm && !masterData.pseudoStatic) {
      <mat-tab-group class="sm:px-2" animationDuration="0">
        <!-- Datatype general data -->
        <mat-tab label="{{ 'general' | transloco }}">
          <dtype-details [dtypeForm]="dtypeForm"></dtype-details>
        </mat-tab>
        <!-- Form fields -->
        <mat-tab label="{{ 'fields' | transloco }}">
          <ng-template matTabContent>
            <dtype-fieldlist [dtype]="masterData" [locator]="locator" [readonly]="true"></dtype-fieldlist>
          </ng-template>
        </mat-tab>
        <!-- Form categories -->
        <!-- <mat-tab label="{{ 'categories' | transloco }}">
        <ng-template matTabContent>
          Categorías
        </ng-template>
      </mat-tab> -->
      <!-- TODO: Solo para maestros -->
      <!-- List config -->
      <mat-tab label="{{ 'listConfig' | transloco }}">
        <ng-template matTabContent>
          <dtype-list-config [dtype]="masterData" [readonly]="true"></dtype-list-config>
        </ng-template>
      </mat-tab>
      <!-- List preview -->
      <mat-tab label="{{ 'listPreview' | transloco }}">
        <ng-template matTabContent>
          <dtype-preview-table [dtype]="masterData"></dtype-preview-table>
        </ng-template>
      </mat-tab>
      <!-- Editor preview -->
      <mat-tab label="{{ 'editorPreview' | transloco }}">
        <ng-template matTabContent>
          <dtype-editor-preview [dtype]="masterData"></dtype-editor-preview>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  }

  <!-- Pseudostatic masters  -->
  @if (masterData && dtypeForm && masterData.pseudoStatic) {
    <dtype-details class="sm:px-2" [dtypeForm]="dtypeForm" [isUpdate]="!isNew"></dtype-details>
  }
</div>
</ng-template>

<!-- Database Tables View -->
<ng-template #databaseView>
  <!-- Header -->
  <div class="z-10 relative flex flex-row items-center flex-0 w-full bg-gray-100 dark:bg-transparent">
    <div class="flex flex-col flex-auto items-center justify-start">
      <!-- Go to Buttons -->
      <div class="flex p-4 items-center justify-start w-full">
        <!-- Go to summary view-->
        <button mat-raised-button class="mat-focus-indicator p-4 mat-stroked-button mat-button-base mr-4" (click)="changeView()">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'summary' | transloco}}</span>
        </button>
        <!-- Go to data -->
        @if (repo && repo.status !== 'DESIGN') {
          <button mat-raised-button class="mr-4"
            [routerLink]="['../data']" [queryParams]="params" (click)="changeView()">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'data' | transloco }}</span>
          </button>
        }

        <!-- Go to design-->
        @if (repo && repo.status !== 'STATIC') {
          <button mat-raised-button class="mr-4"
            [routerLink]="['../design']" [queryParams]="params" (click)="changeView()" [disabled]="repo?.locked && repo?.dtypeToGoLiveRequest">
            <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
            <span class="pl-1">{{ 'design' | transloco }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
    fuseScrollReset>
    <database-table-view [data]="repo" [uri]="uri" [dtypeLocator]="dtypeLocator"></database-table-view>
  </div>
</ng-template>

<!-- Quarantine View -->
<ng-template #quarantineView>
  <!-- Header -->
  <div class="z-10 relative flex flex-row items-center flex-0 w-full bg-gray-100 dark:bg-transparent">
    <div class="flex flex-col flex-auto items-center justify-start">
      <!-- Go to Buttons -->
      <div class="flex p-4 items-center justify-start w-full">
        <!-- Go to summary view-->
        <button mat-raised-button class="mat-focus-indicator p-4 mat-stroked-button mat-button-base mr-4" (click)="changeQuarantineView()">
          <mat-icon class="mat-icon notranslate icon-size-5 mat-icon-no-color" aria-hidden="true"[svgIcon]="'heroicons_solid:external-link'"></mat-icon>
          <span class="pl-1">{{ 'back' | transloco}}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="flex flex-col flex-auto flex-shrink-0 lg:flex-shrink p-3 lg:overflow-y-auto bg-gray-100 dark:bg-transparent"
    fuseScrollReset>
    <dtype-quarantine [uri]="uri" [dtypeLocator]="dtypeLocator" (revertView)="changeQuarantineView(true)"></dtype-quarantine>
  </div>
</ng-template>